import { Maybe, nothing } from 'maybeasy';
import * as React from 'react';
import ToastStore from './Store';

/**
 * The toast slot a page owns, so components rendered below it (route
 * children included) can show a toast without the store being threaded
 * through props. Nothing outside a provider means no toast slot.
 */
export const ToastContext = React.createContext<Maybe<ToastStore>>(nothing());
